const lazy = require('lazysizes');
